// @ts-nocheck

/**
 * * `protagonist` - Protagonist
 * `sidekick` - Sidekick
 * `antagonist` - Antagonist
 * `supporting` - Supporting Character
 * `cameo` - Cameo
 */
export type CharacterRoleEnum =
  typeof CharacterRoleEnum[keyof typeof CharacterRoleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CharacterRoleEnum = {
  protagonist: "protagonist",
  sidekick: "sidekick",
  antagonist: "antagonist",
  supporting: "supporting",
  cameo: "cameo",
} as const;
